import { useEffect, useState } from 'react';
import { api, getBackendUrl } from '../api';
export var PartnerEvents;
(function (PartnerEvents) {
    PartnerEvents[PartnerEvents["WIDGET_LOADED"] = 0] = "WIDGET_LOADED";
    PartnerEvents[PartnerEvents["PREVIEW_LOADED"] = 1] = "PREVIEW_LOADED";
})(PartnerEvents || (PartnerEvents = {}));
export var usePartnerEventsTracker = function (_a) {
    var partnerConfig = _a.partnerConfig, isConfigLoaded = _a.isConfigLoaded, isVisible = _a.isVisible, isPreviewVisible = _a.isPreviewVisible;
    var _b = useState(false), widgetLoadedTracked = _b[0], setWidgetLoadedTracked = _b[1];
    var _c = useState(false), previewLoadedTracked = _c[0], setPreviewLoadedTracked = _c[1];
    useEffect(function () {
        if (!isConfigLoaded) {
            return;
        }
        if (isVisible && !widgetLoadedTracked) {
            setWidgetLoadedTracked(true);
            api.trackPartnerEvent(getBackendUrl(partnerConfig.webChatUrl), PartnerEvents.WIDGET_LOADED, partnerConfig.partnerId).catch(function () { });
        }
        if (isVisible && isPreviewVisible && !previewLoadedTracked) {
            setPreviewLoadedTracked(true);
            api.trackPartnerEvent(getBackendUrl(partnerConfig.webChatUrl), PartnerEvents.PREVIEW_LOADED, partnerConfig.partnerId).catch(function () { });
        }
    }, [isVisible, isPreviewVisible, partnerConfig, isConfigLoaded]);
};
